import React from 'react'
import { connect } from 'react-redux'
import agent from '../agent'
import numberHelper from '../util/numberFormatter'
import Loading from './widgets/Loading'
import Header from './widgets/Header'
import QRCode from './widgets/QRCode'
import { Link } from 'react-router-dom'
import {
} from '../constants/actionTypes'
import { BASE_COIN_SYMBOL } from '../constants/config'
const mapStateToProps = state => ({
})

const mapDispatchToProps = dispatch => ({
})

class Settings extends React.Component {
  componentWillMount() {
  }

  componentWillUnmount() {
  }
  render() {
    // sort category a-z :: categories[i]
    // get products by category, sort by name a-z :: categories[i].products

    return (
      <div>
        <Header selected={'settings'} />
        <div id="main"><div id="main-wrap">

          <div id="content">
            <h2>Settings</h2>
            <ul className='LinkList'>
              <li><Link to='/categories/add'>Add Category</Link></li>
              <li><Link to='/categories/manage'>Manage Categories</Link></li>
              <li><Link to='/products/add'>Add Product</Link></li>
              <li><Link to='/products/manage'>Manage Products</Link></li>
            </ul>
          </div>
        </div></div>
      </div>
    )
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Settings)
